/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  ChangeOwnPinDto,
  ChangePasswordRequestDto,
  ChangePasswordResponseDto,
  CompletePinSetupDto,
  RegisterUserDto,
  RequestPasswordResetCommandControllerRequestPasswordResetBody,
  RequestPasswordResetResponseDto,
  ResendVerificationEmailResponseDto,
  SignInUserDto,
  SignInUserResponseDto,
  SignInWithPinDto,
  SignInWithPinResponseDto,
  UpdatePasswordWithTokenRequestDto,
  UpdatePasswordWithTokenResponseDto,
  UserResponseDto,
  VerifyEmailDto,
  VerifyEmailResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * The user re-enters their manager-issued temporary PIN and chooses their own. On success the temporary PIN is invalidated and a session is issued (same custom-token response as pin-login). Only devices a manager has linked may call this; the device is identified by its secret.
 * @summary Complete first-time PIN setup on a shared device
 */
export const completePinSetupCommandControllerCompletePinSetup = (
  completePinSetupDto: CompletePinSetupDto,
  signal?: AbortSignal,
) => {
  return axiosClient<SignInWithPinResponseDto>({
    url: `/v1/auth/pin-setup`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completePinSetupDto,
    signal,
  });
};

export const getCompletePinSetupCommandControllerCompletePinSetupMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>
      >,
      TError,
      { data: CompletePinSetupDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>
    >,
    TError,
    { data: CompletePinSetupDto },
    TContext
  > => {
    const mutationKey = ["completePinSetupCommandControllerCompletePinSetup"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>
      >,
      { data: CompletePinSetupDto }
    > = (props) => {
      const { data } = props ?? {};

      return completePinSetupCommandControllerCompletePinSetup(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompletePinSetupCommandControllerCompletePinSetupMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>
    >
  >;
export type CompletePinSetupCommandControllerCompletePinSetupMutationBody =
  CompletePinSetupDto;
export type CompletePinSetupCommandControllerCompletePinSetupMutationError =
  void;

/**
 * @summary Complete first-time PIN setup on a shared device
 */
export const useCompletePinSetupCommandControllerCompletePinSetup = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>
      >,
      TError,
      { data: CompletePinSetupDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completePinSetupCommandControllerCompletePinSetup>>,
  TError,
  { data: CompletePinSetupDto },
  TContext
> => {
  return useMutation(
    getCompletePinSetupCommandControllerCompletePinSetupMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Verifies the current PIN and replaces it. An incorrect current PIN counts toward the 5-attempt lockout and returns 400 with the remaining attempts.
 * @summary Change your own PIN
 */
export const changeOwnPinCommandControllerChangeOwnPin = (
  changeOwnPinDto: ChangeOwnPinDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/auth/change-pin`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changeOwnPinDto,
    signal,
  });
};

export const getChangeOwnPinCommandControllerChangeOwnPinMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>,
    TError,
    { data: ChangeOwnPinDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>,
  TError,
  { data: ChangeOwnPinDto },
  TContext
> => {
  const mutationKey = ["changeOwnPinCommandControllerChangeOwnPin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>,
    { data: ChangeOwnPinDto }
  > = (props) => {
    const { data } = props ?? {};

    return changeOwnPinCommandControllerChangeOwnPin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeOwnPinCommandControllerChangeOwnPinMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>
  >;
export type ChangeOwnPinCommandControllerChangeOwnPinMutationBody =
  ChangeOwnPinDto;
export type ChangeOwnPinCommandControllerChangeOwnPinMutationError = void;

/**
 * @summary Change your own PIN
 */
export const useChangeOwnPinCommandControllerChangeOwnPin = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>,
      TError,
      { data: ChangeOwnPinDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeOwnPinCommandControllerChangeOwnPin>>,
  TError,
  { data: ChangeOwnPinDto },
  TContext
> => {
  return useMutation(
    getChangeOwnPinCommandControllerChangeOwnPinMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Register a new user
 */
export const registerUserCommandControllerRegister = (
  registerUserDto: RegisterUserDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UserResponseDto>({
    url: `/v1/auth/register`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerUserDto,
    signal,
  });
};

export const getRegisterUserCommandControllerRegisterMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerUserCommandControllerRegister>>,
    TError,
    { data: RegisterUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerUserCommandControllerRegister>>,
  TError,
  { data: RegisterUserDto },
  TContext
> => {
  const mutationKey = ["registerUserCommandControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerUserCommandControllerRegister>>,
    { data: RegisterUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return registerUserCommandControllerRegister(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterUserCommandControllerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerUserCommandControllerRegister>>
>;
export type RegisterUserCommandControllerRegisterMutationBody = RegisterUserDto;
export type RegisterUserCommandControllerRegisterMutationError = void;

/**
 * @summary Register a new user
 */
export const useRegisterUserCommandControllerRegister = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerUserCommandControllerRegister>>,
      TError,
      { data: RegisterUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerUserCommandControllerRegister>>,
  TError,
  { data: RegisterUserDto },
  TContext
> => {
  return useMutation(
    getRegisterUserCommandControllerRegisterMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Login to application
 */
export const signInUserCommandControllerSignIn = (
  signInUserDto: SignInUserDto,
  signal?: AbortSignal,
) => {
  return axiosClient<SignInUserResponseDto>({
    url: `/v1/auth/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signInUserDto,
    signal,
  });
};

export const getSignInUserCommandControllerSignInMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>,
    TError,
    { data: SignInUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>,
  TError,
  { data: SignInUserDto },
  TContext
> => {
  const mutationKey = ["signInUserCommandControllerSignIn"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>,
    { data: SignInUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return signInUserCommandControllerSignIn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInUserCommandControllerSignInMutationResult = NonNullable<
  Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>
>;
export type SignInUserCommandControllerSignInMutationBody = SignInUserDto;
export type SignInUserCommandControllerSignInMutationError = void;

/**
 * @summary Login to application
 */
export const useSignInUserCommandControllerSignIn = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>,
      TError,
      { data: SignInUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof signInUserCommandControllerSignIn>>,
  TError,
  { data: SignInUserDto },
  TContext
> => {
  return useMutation(
    getSignInUserCommandControllerSignInMutationOptions(options),
    queryClient,
  );
};
/**
 * Only devices a manager has linked may attempt a PIN login; the device is identified by its secret.
 * @summary Log in on a shared device by selecting a user and entering their PIN
 */
export const signInWithPinCommandControllerSignInWithPin = (
  signInWithPinDto: SignInWithPinDto,
  signal?: AbortSignal,
) => {
  return axiosClient<SignInWithPinResponseDto>({
    url: `/v1/auth/pin-login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signInWithPinDto,
    signal,
  });
};

export const getSignInWithPinCommandControllerSignInWithPinMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>,
    TError,
    { data: SignInWithPinDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>,
  TError,
  { data: SignInWithPinDto },
  TContext
> => {
  const mutationKey = ["signInWithPinCommandControllerSignInWithPin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>,
    { data: SignInWithPinDto }
  > = (props) => {
    const { data } = props ?? {};

    return signInWithPinCommandControllerSignInWithPin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInWithPinCommandControllerSignInWithPinMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>
  >;
export type SignInWithPinCommandControllerSignInWithPinMutationBody =
  SignInWithPinDto;
export type SignInWithPinCommandControllerSignInWithPinMutationError = void;

/**
 * @summary Log in on a shared device by selecting a user and entering their PIN
 */
export const useSignInWithPinCommandControllerSignInWithPin = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>,
      TError,
      { data: SignInWithPinDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof signInWithPinCommandControllerSignInWithPin>>,
  TError,
  { data: SignInWithPinDto },
  TContext
> => {
  return useMutation(
    getSignInWithPinCommandControllerSignInWithPinMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Verify user email
 */
export const verifyEmailCommandControllerVerifyEmail = (
  verifyEmailDto: VerifyEmailDto,
  signal?: AbortSignal,
) => {
  return axiosClient<VerifyEmailResponseDto>({
    url: `/v1/auth/verify-email`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: verifyEmailDto,
    signal,
  });
};

export const getVerifyEmailCommandControllerVerifyEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>,
    TError,
    { data: VerifyEmailDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>,
  TError,
  { data: VerifyEmailDto },
  TContext
> => {
  const mutationKey = ["verifyEmailCommandControllerVerifyEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>,
    { data: VerifyEmailDto }
  > = (props) => {
    const { data } = props ?? {};

    return verifyEmailCommandControllerVerifyEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailCommandControllerVerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>
>;
export type VerifyEmailCommandControllerVerifyEmailMutationBody =
  VerifyEmailDto;
export type VerifyEmailCommandControllerVerifyEmailMutationError = unknown;

/**
 * @summary Verify user email
 */
export const useVerifyEmailCommandControllerVerifyEmail = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>,
      TError,
      { data: VerifyEmailDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmailCommandControllerVerifyEmail>>,
  TError,
  { data: VerifyEmailDto },
  TContext
> => {
  return useMutation(
    getVerifyEmailCommandControllerVerifyEmailMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Resend verification email
 */
export const resendVerificationEmailCommandControllerResendVerificationEmail = (
  signal?: AbortSignal,
) => {
  return axiosClient<ResendVerificationEmailResponseDto>({
    url: `/v1/auth/resend-verification-email`,
    method: "POST",
    signal,
  });
};

export const getResendVerificationEmailCommandControllerResendVerificationEmailMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resendVerificationEmailCommandControllerResendVerificationEmail
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resendVerificationEmailCommandControllerResendVerificationEmail
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "resendVerificationEmailCommandControllerResendVerificationEmail",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resendVerificationEmailCommandControllerResendVerificationEmail
        >
      >,
      void
    > = () => {
      return resendVerificationEmailCommandControllerResendVerificationEmail();
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResendVerificationEmailCommandControllerResendVerificationEmailMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resendVerificationEmailCommandControllerResendVerificationEmail
      >
    >
  >;

export type ResendVerificationEmailCommandControllerResendVerificationEmailMutationError =
  void;

/**
 * @summary Resend verification email
 */
export const useResendVerificationEmailCommandControllerResendVerificationEmail =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resendVerificationEmailCommandControllerResendVerificationEmail
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resendVerificationEmailCommandControllerResendVerificationEmail
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getResendVerificationEmailCommandControllerResendVerificationEmailMutationOptions(
        options,
      ),
      queryClient,
    );
  };
/**
 * @summary Update password with verification token
 */
export const updatePasswordWithTokenCommandControllerUpdatePasswordWithToken = (
  updatePasswordWithTokenRequestDto: UpdatePasswordWithTokenRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdatePasswordWithTokenResponseDto>({
    url: `/v1/auth/update-password-with-token`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updatePasswordWithTokenRequestDto,
    signal,
  });
};

export const getUpdatePasswordWithTokenCommandControllerUpdatePasswordWithTokenMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
        >
      >,
      TError,
      { data: UpdatePasswordWithTokenRequestDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
      >
    >,
    TError,
    { data: UpdatePasswordWithTokenRequestDto },
    TContext
  > => {
    const mutationKey = [
      "updatePasswordWithTokenCommandControllerUpdatePasswordWithToken",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
        >
      >,
      { data: UpdatePasswordWithTokenRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return updatePasswordWithTokenCommandControllerUpdatePasswordWithToken(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePasswordWithTokenCommandControllerUpdatePasswordWithTokenMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
      >
    >
  >;
export type UpdatePasswordWithTokenCommandControllerUpdatePasswordWithTokenMutationBody =
  UpdatePasswordWithTokenRequestDto;
export type UpdatePasswordWithTokenCommandControllerUpdatePasswordWithTokenMutationError =
  void;

/**
 * @summary Update password with verification token
 */
export const useUpdatePasswordWithTokenCommandControllerUpdatePasswordWithToken =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
          >
        >,
        TError,
        { data: UpdatePasswordWithTokenRequestDto },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updatePasswordWithTokenCommandControllerUpdatePasswordWithToken
      >
    >,
    TError,
    { data: UpdatePasswordWithTokenRequestDto },
    TContext
  > => {
    return useMutation(
      getUpdatePasswordWithTokenCommandControllerUpdatePasswordWithTokenMutationOptions(
        options,
      ),
      queryClient,
    );
  };
/**
 * @summary Change password for authenticated user
 */
export const changePasswordCommandControllerChangePassword = (
  changePasswordRequestDto: ChangePasswordRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<ChangePasswordResponseDto>({
    url: `/v1/auth/change-password`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changePasswordRequestDto,
    signal,
  });
};

export const getChangePasswordCommandControllerChangePasswordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>,
    TError,
    { data: ChangePasswordRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>,
  TError,
  { data: ChangePasswordRequestDto },
  TContext
> => {
  const mutationKey = ["changePasswordCommandControllerChangePassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>,
    { data: ChangePasswordRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return changePasswordCommandControllerChangePassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordCommandControllerChangePasswordMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>
  >;
export type ChangePasswordCommandControllerChangePasswordMutationBody =
  ChangePasswordRequestDto;
export type ChangePasswordCommandControllerChangePasswordMutationError = void;

/**
 * @summary Change password for authenticated user
 */
export const useChangePasswordCommandControllerChangePassword = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>,
      TError,
      { data: ChangePasswordRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePasswordCommandControllerChangePassword>>,
  TError,
  { data: ChangePasswordRequestDto },
  TContext
> => {
  return useMutation(
    getChangePasswordCommandControllerChangePasswordMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Request password reset
 */
export const requestPasswordResetCommandControllerRequestPasswordReset = (
  requestPasswordResetCommandControllerRequestPasswordResetBody: RequestPasswordResetCommandControllerRequestPasswordResetBody,
  signal?: AbortSignal,
) => {
  return axiosClient<RequestPasswordResetResponseDto>({
    url: `/v1/auth/request-password-reset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestPasswordResetCommandControllerRequestPasswordResetBody,
    signal,
  });
};

export const getRequestPasswordResetCommandControllerRequestPasswordResetMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof requestPasswordResetCommandControllerRequestPasswordReset
        >
      >,
      TError,
      { data: RequestPasswordResetCommandControllerRequestPasswordResetBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof requestPasswordResetCommandControllerRequestPasswordReset
      >
    >,
    TError,
    { data: RequestPasswordResetCommandControllerRequestPasswordResetBody },
    TContext
  > => {
    const mutationKey = [
      "requestPasswordResetCommandControllerRequestPasswordReset",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof requestPasswordResetCommandControllerRequestPasswordReset
        >
      >,
      { data: RequestPasswordResetCommandControllerRequestPasswordResetBody }
    > = (props) => {
      const { data } = props ?? {};

      return requestPasswordResetCommandControllerRequestPasswordReset(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RequestPasswordResetCommandControllerRequestPasswordResetMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof requestPasswordResetCommandControllerRequestPasswordReset
      >
    >
  >;
export type RequestPasswordResetCommandControllerRequestPasswordResetMutationBody =
  RequestPasswordResetCommandControllerRequestPasswordResetBody;
export type RequestPasswordResetCommandControllerRequestPasswordResetMutationError =
  unknown;

/**
 * @summary Request password reset
 */
export const useRequestPasswordResetCommandControllerRequestPasswordReset = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof requestPasswordResetCommandControllerRequestPasswordReset
        >
      >,
      TError,
      { data: RequestPasswordResetCommandControllerRequestPasswordResetBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof requestPasswordResetCommandControllerRequestPasswordReset>
  >,
  TError,
  { data: RequestPasswordResetCommandControllerRequestPasswordResetBody },
  TContext
> => {
  return useMutation(
    getRequestPasswordResetCommandControllerRequestPasswordResetMutationOptions(
      options,
    ),
    queryClient,
  );
};
